module.exports = __webpack_public_path__ + "img/receita_federal.c55aebb7.png";